import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import {
  headersProaqItens,
  valoresExibidosOffCanvasProcessosJuridicos,
} from './auxiliarProcessosJuridicos';
import SubAbasProcessosJuridicos from './subabasProcessosJuridicos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import CardFase from '../../../../components/CardFase';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useStatusVersao } from '../../../../services/enum/useStatusVersao';
import { getNotaVersao } from '../../../../services/gestaoSisAF/notaVersaoSisafService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
} from '../../../../utils/swal';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
//const entity = ENTITY.ENTITY_Contratos;

type ProdutoOption = {
  value: number;
  label: string;
};

export default function ProcessosJuridicosFicha() {
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Contratos')
      ?.value || '0',
  );

  // Estado para armazenar a lista de produtos e o estado de carregamento
  const [listaProdutosDAF] = useState<ProdutoOption[]>([]); // Ajustado para o tipo { value, label }

  const theme = useTheme();

  const componenteAf = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Básico' },
    { value: 2, label: 'Especializado' },
    { value: 3, label: 'Estratégico' },
  ];

  const nivelCriticidade = [
    { value: 99, label: 'Não informado' },
    { value: 1, label: '1 - Pouco crítico' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10 - Muito crítico' },
  ];

  const faseProcessoJuridico = [
    { value: '1', label: 'Recepção do Processo' },
    { value: '10', label: 'Recepção do Processo' },
    { value: '2', label: 'Elaboração da Resposta' },
    { value: '3', label: 'Validação Técnica' },
    { value: '4', label: 'Validação Diretoria' },
    { value: '5', label: 'Finalizado' },
  ];

  const tipoProcessoJuridico = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'ACP - Ação Civil Pública' },
    { value: 2, label: 'AJ - Ação Judicial' },
    { value: 3, label: 'Auditoria' },
    { value: 4, label: 'CEJUSC/SP' },
    { value: 5, label: 'PAJ - Processo de Assistência Jurídica' },
    { value: 6, label: 'RA - Requerimento Administrativo' },
    { value: 7, label: 'Representação' },
    { value: 8, label: 'RIC - Requerimento de Informações (CD/SF)' },
    { value: 9, label: 'TCE - Tomada de Contas Especial' },
    { value: 99, label: 'Outro' },
  ];

  const [proaqFaseStateArray] = useState<Array<boolean>>([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showModalFaseInfo, setShowModalFaseInfo] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showModalFaseEvolucao, setShowModalFaseEvolucao] =
    useState<boolean>(false);
  // Verificar permissões para ações
  // const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  //const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  const canDelete = isActionAllowed(MODULO, 'delete', papelUsuarioOptions);
  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const statusVersao = useStatusVersao();
  const [linhas, setLinhas] = useState([0]);

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formNotaVersao, setFormNotaVersao] = useState({
    usuarioId: userID,
    statusVersao: '',
    dataVersao: '',
    tagVersao: '',
    descricao: '',
    link: '',
    observacoes: '',
  });

  const [formKitProduto] = useState({
    id: 0,
    usuarioId: userID,
    statusKit: 0,
    componenteAF: 0,
    nomeKit: '',
    descricao: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getNotaVersao(id);
      setLogData(registroData);
      setFormNotaVersao({
        usuarioId: userID,
        statusVersao: registroData.statusVersao,
        dataVersao: registroData.dataVersao,
        tagVersao: registroData.tagVersao,
        descricao: registroData.descricao,
        link: registroData.link,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';

    console.log('Status:', formNotaVersao.statusVersao);

    const status = String(formNotaVersao.statusVersao);
    console.log('Status atual:', status); // Adicionado para depurar

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? verde
            : status === '3'
              ? vermelho
              : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formNotaVersao.statusVersao]);

  const [isDateReadOnly, setIsDateReadOnly] = useState(true);
  useEffect(() => {
    if (
      formNotaVersao.statusVersao == '1' ||
      formNotaVersao.statusVersao == '3'
    ) {
      setIsDateReadOnly(true);
      setFormNotaVersao((prev) => ({
        ...prev,
        dataVersao: '',
      }));
    } else {
      setIsDateReadOnly(false);
    }
  }, [formNotaVersao.statusVersao]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasProcessosJuridicos(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/procjur/processos/ficha/dadosgerais`,
      },
      {
        label: 'Manifestação Técnica',
        rota: `/daf/procjur/processos/ficha/manifestacaotecnica`,
      },
    ];
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    console.log('Campo alterado:', name, 'Novo valor:', value); // Verificar qual campo está sendo alterado e o valor
    setFormNotaVersao((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusVersao) {
      errors.push('<b>Status da versão</b> é obrigatório.');
    }

    if (!form.tagVersao) {
      errors.push('Nome da <b>tag da versão</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição</b> é obrigatório.');
    }

    if (form.statusVersao == '2' && form.dataVersao == '') {
      errors.push('<b>Data da versão</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalErro(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      console.log(formNotaVersao);

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(
        `/api/notaversaosisaf/`,
        formToSend,
      );

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/maisopcoes/notas/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      const response = await httpClient.patch(
        `/api/notaversaosisaf/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/notaversaosisaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/notas');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  type ProdutoDoKit = {
    usuarioId: number;
    produtoDAFid: number;
    produtoDAF: string;
    kitProdutoId: number;
    quantidade: string | number;
    observacoes: string;
  };
  const [produtosDoKit, setProdutosDoKit] = useState<ProdutoDoKit[]>([
    {
      usuarioId: 0,
      produtoDAFid: 0,
      produtoDAF: '',
      kitProdutoId: 0,
      quantidade: '',
      observacoes: '',
    },
  ]);

  const handleChangeProduto = (
    event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
    index: number,
  ) => {
    const { value } = event.target;
    const produtoSelecionado = listaProdutosDAF.find(
      (produto) => produto.value === parseInt(value, 10),
    );

    if (!produtoSelecionado) {
      return; // Caso nenhum produto seja encontrado, não faça nada
    }

    // Verificar se o produto já foi selecionado em outra linha (excluindo a linha atual)
    const produtoJaSelecionado = produtosDoKit.some(
      (produto, idx) =>
        produto.produtoDAFid === produtoSelecionado.value && idx !== index,
    );

    if (produtoJaSelecionado) {
      // Se o produto já foi selecionado, exibir um erro e não fazer a atualização
      swalErro('Este produto já foi selecionado em outra linha.');
      return;
    }

    // Se não houver problema, prosseguir com a atualização
    const updatedProdutos = [...produtosDoKit];
    updatedProdutos[index] = {
      ...updatedProdutos[index],
      produtoDAFid: produtoSelecionado.value, // Atualiza o ID do produto selecionado
      produtoDAF: produtoSelecionado.label,
      kitProdutoId: formKitProduto.id,
    };
    setProdutosDoKit(updatedProdutos);
  };

  // Função para remover formatação e manter apenas números
  // const handleChangeQuantidade = (
  //   event: React.ChangeEvent<HTMLInputElement>,
  //   index: number,
  // ) => {
  //   const { value } = event.target;

  //   // Remover qualquer coisa que não seja dígito
  //   const rawValue = value.replace(/[^\d]/g, '');

  //   // Atualizar o valor no estado com o valor bruto, não formatado
  //   const updatedProdutos = [...produtosDoKit];
  //   updatedProdutos[index] = {
  //     ...updatedProdutos[index],
  //     quantidade: rawValue,
  //   };
  //   setProdutosDoKit(updatedProdutos);
  // };

  // Função para aplicar a formatação ao perder o foco
  // const handleBlurQuantidade = (index: number) => {
  //   const updatedProdutos = [...produtosDoKit];
  //   const quantidade = updatedProdutos[index].quantidade;

  //   if (typeof quantidade === 'string' && quantidade !== '') {
  //     // Converter para número e formatar com separadores de milhar
  //     const formattedValue = new Intl.NumberFormat('de-DE').format(
  //       Number(quantidade),
  //     );
  //     updatedProdutos[index] = {
  //       ...updatedProdutos[index],
  //       quantidade: formattedValue,
  //     };
  //     setProdutosDoKit(updatedProdutos);
  //   }
  // };

  // Adiciona uma nova linha
  const handleInserirProduto = () => {
    setLinhas((prevLinhas) => [...prevLinhas, prevLinhas.length]);
    setProdutosDoKit((prevProdutos) => [
      ...prevProdutos,
      {
        usuarioId: userID,
        produtoDAFid: 0,
        produtoDAF: '',
        kitProdutoId: formKitProduto.id,
        quantidade: '',
        observacoes: '',
      },
    ]);
  };

  const handleRemoverProduto = () => {
    if (linhas.length > 1) {
      // Remover a última linha e atualizar os produtos
      setLinhas((prevLinhas) => prevLinhas.slice(0, -1));
      setProdutosDoKit((prevProdutos) => prevProdutos.slice(0, -1));
    } else {
      swalErro(
        'Não é possível remover. Pelo menos um produto deve estar presente.',
      );
    }
  };

  // Função auxiliar para formatar a quantidade para exibição
  // const formatarQuantidadeParaExibir = (quantidade: string | number) => {
  //   if (typeof quantidade === 'string' && quantidade !== '') {
  //     return new Intl.NumberFormat('de-DE').format(Number(quantidade));
  //   }
  //   if (typeof quantidade === 'number') {
  //     return new Intl.NumberFormat('de-DE').format(quantidade);
  //   }
  //   return '';
  // };

  const dataTableExample = [
    {
      id: '1',
      nome: 'Produto A',
      categoria: 'Categoria 1',
      preco: 'R$ 10,00',
      estoque: 100,
    },
    {
      id: '2',
      nome: 'Produto B',
      categoria: 'Categoria 2',
      preco: 'R$ 20,00',
      estoque: 50,
    },
  ];

  const dataOffCanvasExample = [
    {
      id: '1',
      nome: 'Produto A',
      categoria: 'Categoria 1',
      descricao: 'Este é o produto A, muito popular na Categoria 1.',
      detalhes: 'Detalhes adicionais sobre o Produto A.',
      estoque: 100,
    },
    {
      id: '2',
      nome: 'Produto B',
      categoria: 'Categoria 2',
      descricao: 'Produto B é conhecido por sua qualidade premium.',
      detalhes: 'Mais informações sobre o Produto B.',
      estoque: 50,
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showModalItem, setShowModalItem] = useState<boolean>(false);
  const handleShowModalItem = () => {
    setShowModalItem((prev) => !prev);
  };

  // const handleShowModalFase = () => {
  //   setShowModalFase((prev) => !prev);
  //   handleClearFormProaqFase();
  // };

  const handleShowModalFaseInfo = () => {
    setShowModalFaseInfo((prev) => !prev);
  };
  const handleShowModalFaseEvolucao = () => {
    setShowModalFaseEvolucao((prev) => !prev);
  };

  const handleRowClickFase = (item: any) => {
    console.log('Fase clicada:', item);
    alert('teste');
  };

  // const handleInserirFase = () => {
  //   alert('teste');
  // };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/procjur/processos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          <BoxConteudo boxTitulo="Evolução Processual">
            {/* Evolução - Cards */}
            <CustomRow className="g-0">
              {faseProcessoJuridico &&
                faseProcessoJuridico.map(
                  (item, index) =>
                    index !== 0 && (
                      <CustomCol>
                        <CardFase
                          key={item.value}
                          onClick={() => {
                            if (
                              proaqFaseStateArray[parseInt(item.value, 10) - 1]
                            ) {
                              handleRowClickFase(item.value.toString());
                            } else {
                              handleShowModalFaseEvolucao();
                            }
                          }}
                          titulo={item.label}
                          status={proaqFaseStateArray[index - 1]}
                          dataEntrada={'-'}
                          dataSaida={'-'}
                          dias={'-'}
                        />
                      </CustomCol>
                    ),
                )}
            </CustomRow>
            <Col className="d-flex justify-content-end gap-2">
              <CustomButton
                label="Info"
                bgColor={theme.colors.botaoAcao.cinza} // Cor cinza
                textColor="#ffffff" // Texto branco
                // onClick={handleClearFiltros}
                onClick={handleShowModalFaseInfo}
              />
              <CustomButton
                label="Editar"
                bgColor={theme.colors.botaoAcao.amarelo}
                textColor="#ffffff" // Texto branco
                // onClick={handleClearFiltros}
                onClick={handleShowModalFaseEvolucao}
              />
            </Col>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Identificação do processo">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="250px">
                <SelectInput
                  name="statusVersao"
                  options={nivelCriticidade}
                  label="Nível Criticidade"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="240px">
                <Input
                  name="link"
                  label="NUP"
                  value={formNotaVersao.link}
                  id="nup"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol width="400px">
                <SelectInput
                  name="statusVersao"
                  options={tipoProcessoJuridico}
                  label="Tipo de Processo"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="link"
                  label="Outro"
                  value={formNotaVersao.link}
                  id="tipoProcesso_outro"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>{' '}
            <CustomRow>
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Referência na origem"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Órgão diligenciador"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol
                width="200px"
                style={{ alignSelf: 'flex-end', marginBottom: '0px' }}
              >
                <CustomButton
                  label="Editar Lista de Órgãos"
                  bgColor={theme.colors.amarelogov}
                  textColor="#ffffff" // Texto branco
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="300px">
                <Input
                  name="numeroSEI"
                  label="Nº SEI"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataVersao"
                  label="Data do Documento"
                  value={formNotaVersao.dataVersao}
                  id="dataVersao"
                  onChange={handleChange}
                  type="date"
                  readonly={isDateReadOnly}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="numeroSEI"
                  label="Documento"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="numeroSEI"
                  label="Assunto"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="300px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Há doc. de encaminhamento ao DAF?"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="300px">
                <Input
                  name="numeroSEI"
                  label="Nº SEI"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="numeroSEI"
                  label="Documento de encaminhamento"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Produtos farmacêuticos">
            {produtosDoKit.map((produto, index) => (
              <CustomRow key={index}>
                <CustomCol width="100px">
                  <Input
                    id={`idProduto-${index}`}
                    name={`idProduto-${index}`}
                    label={`ID ${index + 1}`}
                    value={produto.produtoDAFid || ''}
                    onChange={(e) => handleChangeProduto(e, index)}
                    readonly
                  />
                </CustomCol>
                <CustomCol>
                  <SelectInput
                    name={`produtoDAF-${index}`}
                    options={listaProdutosDAF}
                    label={`Produto Farmacêutico ${index + 1}`}
                    value={produto.produtoDAFid || ''}
                    onChange={(e) => handleChangeProduto(e, index)}
                  />
                </CustomCol>
                <CustomCol width="250px">
                  <SelectInput
                    name="statusVersao"
                    options={componenteAf}
                    label="Componente AF"
                    value={formNotaVersao.statusVersao}
                    onChange={handleChange}
                  />
                </CustomCol>
              </CustomRow>
            ))}
            <CustomRow style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {fichaID === 'undefined' ? (
                <WorkspaceBotoes inserir inserirDisabled={true} />
              ) : (
                <WorkspaceBotoes
                  inserir
                  onClickInserir={handleInserirProduto}
                  remover
                  onClickRemover={handleRemoverProduto}
                />
              )}
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Entes envolvidos">
            {produtosDoKit.map((produto, index) => (
              <CustomRow key={index}>
                <CustomCol width="100px">
                  <Input
                    id={`idProduto-${index}`}
                    name={`idProduto-${index}`}
                    label={`ID ${index + 1}`}
                    value={produto.produtoDAFid || ''}
                    onChange={(e) => handleChangeProduto(e, index)}
                    readonly
                  />
                </CustomCol>
                <CustomCol width="200px">
                  <SelectInput
                    name={`produtoDAF-${index}`}
                    options={listaProdutosDAF}
                    label={`UF ${index + 1}`}
                    value={produto.produtoDAFid || ''}
                    onChange={(e) => handleChangeProduto(e, index)}
                  />
                </CustomCol>
                <CustomCol>
                  <SelectInput
                    name="statusVersao"
                    options={componenteAf}
                    label="Município"
                    value={formNotaVersao.statusVersao}
                    onChange={handleChange}
                  />
                </CustomCol>
              </CustomRow>
            ))}
            <CustomRow style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {fichaID === 'undefined' ? (
                <WorkspaceBotoes inserir inserirDisabled={true} />
              ) : (
                <WorkspaceBotoes
                  inserir
                  onClickInserir={handleInserirProduto}
                  remover
                  onClickRemover={handleRemoverProduto}
                />
              )}
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Recomendações do órgão de controle">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="100%">
                <Tabela
                  headers={headersProaqItens}
                  dataTable={dataTableExample}
                  displayValues={valoresExibidosOffCanvasProcessosJuridicos}
                  onRowClick={handleChange}
                  dataOffCanvas={dataOffCanvasExample}
                />
              </CustomCol>
            </CustomRow>
            <Col className="d-flex justify-content-end">
              <CustomButton
                label="Inserir item"
                bgColor={theme.colors.botaoAcao.azul}
                textColor="#ffffff"
                onClick={handleShowModalItem}
                disabled={fichaID == 'undefined' ? true : false}
              />
            </Col>
          </BoxConteudo>

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formNotaVersao.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={!canDelete}
            onClickDelete={handleDelete}
            save
            saveDisabled={!canSave}
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
